import {observable, computed, autorun, reaction, action, runInAction, toJS} from 'mobx';

export class AccessoriesForm {
  initialValues = observable.map([]);
  dirtyValues = observable.map([]);

  @computed get values() {
    let result = toJS(this.initialValues);
    this.dirtyValues.forEach((v, k) => {
      result[k] = v;
    })
    return observable.map(result);
  }

  @action.bound incAmount(id, max) {
    if(max && this.values.get(id)>=max) {
      return;
    }
    this.dirtyValues.set(id, this.values.get(id) + 1); 
  }

  @action.bound decAmount(id) {
    this.dirtyValues.set(id, Math.max(this.values.get(id) - 1, 0));
  }

  canInc(id, max) {
    if(max && this.values.get(id)>=max) {
      return false;
    }    
    return true;
  }

  canDec(id) {
    return this.values.get(id) > 0;
  }

  constructor() {
    
  }
}


// WEBPACK FOOTER //
// ./src/view/AccessoriesForm.js